import { css } from 'styled-components'

export default css`
  &.ExpenseReport {
    padding: 26px 24px;
  }
`